import { Col, Row, Skeleton } from 'ui';

const ConsentsStepSkeleton = () => (
  <Row gutter={['ms', 'ms']}>
    <Col span={24}>
      <Skeleton active paragraph={{ rows: 2 }} title={false} />
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Input active block />
    </Col>
    <Col span={24}>
      <Skeleton.Button active block />
    </Col>
  </Row>
);

export default ConsentsStepSkeleton;
